export default __webpack_public_path__ + "static/media/carbonOffset.6e439131.svg";